export enum FlowUnits {
  LITERS_PER_SECOND = 'l/s',
  CUBIC_METERS_PER_HOUR = 'm³/h',
  KW = 'kW',
  KVAR = 'kVar',
}
